// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0782c10b","239":"64c838d4","453":"37e702f6","732":"47765ddf"}[chunkId] + ".chunk.js";
};